import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNichePrisoners(groupType, groupCodes = []) {
  const queryKey = ['nichePrisoners', groupType, groupCodes];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const searchParams = new URLSearchParams([
        groupType && ['groupType', groupType],
        ...groupCodes.map((code) => ['groupCodes', code]),
      ]);

      return platformApi
        .get('niche/prisoners', { searchParams, signal })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
